import React, { useState, useEffect } from 'react';

function LiveLocation() {
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    error: null,
  });

  useEffect(() => {
    if (!navigator.geolocation) {
      setLocation((prev) => ({
        ...prev,
        error: 'Geolocation is not supported by your browser.',
      }));
      return;
    }

    const watcher = navigator.geolocation.watchPosition(
      (position) => {
        setLocation({
          latitude: position.coords.latitude.toFixed(6),
          longitude: position.coords.longitude.toFixed(6),
          error: null,
        });
      },
      (err) => {
        setLocation((prev) => ({
          ...prev,
          error: 'Unable to retrieve location: ' + err.message,
        }));
      },
      {
        enableHighAccuracy: true,
        maximumAge: 1000,
        timeout: 10000,
      }
    );

    return () => {
      navigator.geolocation.clearWatch(watcher);
    };
  }, []);

  return (
    <div style={styles.container}>
      <h2>📍 Live Location</h2>
      {location.error ? (
        <p style={{ color: 'red' }}>{location.error}</p>
      ) : location.latitude && location.longitude ? (
        <>
          <p>Latitude: <strong>{location.latitude}</strong></p>
          <p>Longitude: <strong>{location.longitude}</strong></p>
        </>
      ) : (
        <p>Fetching location...</p>
      )}
    </div>
  );
}

const styles = {
  container: {
    fontFamily: 'Arial',
    textAlign: 'center',
    padding: '20px',
    background: '#f5f5f5',
    borderRadius: '8px',
    width: '300px',
    margin: '40px auto',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
  },
};

export default LiveLocation;
